module.exports = __webpack_public_path__ + "img/03-9区域指标系统.c6eb5854.png";